import { AppConstants } from '../common/APIConstants';

export const ALL_DISTRICT_OR_DIVISION = { value: "All", label: "All" }

// get user roles from session storage using AUTH_TOKEN
export const getUserRoles = () => {
    const jsonStringOBJ = sessionStorage.getItem('AUTH_TOKEN')
    const roleObj = JSON.parse(jsonStringOBJ)
    return roleObj
}
